import { SQUARESPACE_PAGES } from '~/i18n/squarespacePages';

/**
 * Slugs the root-level generic `[slug]` catch-all must NOT render.
 * One source of truth. The proxy single-segment rewrite (proxy.ts) also consumes
 * `isReservedSlug` to decide what NOT to rewrite, so a generic page and a reserved path
 * can never disagree. Reserved app paths are single-segment route names that carry
 * non-CMS meaning (auth, account, checkout, the Squarespace proxy pages, …); reserving
 * them stops a future CMS `sitePage` slug from shadowing a real app route.
 */
export const RESERVED_SLUGS = new Set<string>([
  // Top-level / legacy app route segments (each renders, or parents a route, outside [lang])
  'auth',
  'account',
  'checkout',
  'ezine',
  'map',
  'journey',
  'journey-guide',
  'journey-template',
  'blueprint-index',
  'component-preview',
  'preview',
  'partner-redirect',
  '_internal',

  // Single-segment route name matching middleware routing without a redirect
  'inspiration',
  'legal',
  'partner',

  // Single-segment Squarespace proxy pages
  ...SQUARESPACE_PAGES.map((path) => path.replace(/^\//, ''))
]);

export function isReservedSlug(slug: string): boolean {
  return RESERVED_SLUGS.has(slug);
}
